<template>
  <div class="app" id="app">
    <meta name="viewport" content="initial-scale=1">
    <DeveloperRoom />
  </div>
</template>

<script>
import DeveloperRoom from './components/DeveloperRoom.vue'

export default {
  name: 'app',
  components: {
    DeveloperRoom
  }
}
</script>

<style>

 body {
   padding: 0px;
   margin: 0px;
 }

  .app {
    height: 100vh;
  }

</style>
